/**
 * HTTP client for the xyGIS CRUD endpoints.
 *
 * Wraps the three flavours of axios call that XyGisCrudService makes:
 *   - query / queryCount → POST {layerUrl}/Query
 *   - applyEdits          → POST {xyApiUrl}/ApplyEdits (multipart)
 *
 * Errors propagate via Promise rejection; logging stays here so callers
 * don't repeat the pattern. The GetFilesByTags fetch inside
 * XyGisCrudService.attachAttachments is an archive-domain call leaking
 * into the xyGIS service — flagged for a separate cleanup and NOT
 * touched by this client.
 */
import axios from 'axios'

export const xyGisClient = {
  async query<T = unknown>(layerUrl: string, body: unknown): Promise<T> {
    try {
      const r = await axios.post<T>(`${layerUrl}/Query`, body)
      return r.data
    } catch (e) {
      console.error('xyGisClient.query failed', e)
      throw e
    }
  },

  async queryCount(layerUrl: string, body: unknown): Promise<number> {
    try {
      const r = await axios.post<number>(`${layerUrl}/Query`, {...(body as object), CountOnly: true})
      return r.data
    } catch (e) {
      console.error('xyGisClient.queryCount failed', e)
      throw e
    }
  },

  async applyEdits<T = unknown>(xyApiUrl: string, formData: FormData): Promise<T> {
    try {
      const r = await axios.post<T>(`${xyApiUrl}/ApplyEdits`, formData, {
        headers: {'Content-Type': 'multipart/form-data;'}
      })
      return r.data
    } catch (e) {
      console.error('xyGisClient.applyEdits failed', e)
      throw e
    }
  }
}
